export function arrayInsertByIndex<T>(
  arr: T[],
  index: number,
  newItem: T
): T[] {
  return [...arr.slice(0, index), newItem, ...arr.slice(index)];
}

export default arrayInsertByIndex;
